/**
 * Jaettu etusivun leaderboard + AdminSettings (mittarit, lajittelu).
 */

export const LEADERBOARD_METRIC_ORDER = ['time', 'points', 'winRate', 'avgPoints'];

export function getOrderedLeaderboardMetrics(visibleMetrics) {
  const raw =
    Array.isArray(visibleMetrics) && visibleMetrics.length > 0
      ? visibleMetrics
      : ['time', 'points'];
  const set = new Set(raw);
  return LEADERBOARD_METRIC_ORDER.filter((k) => set.has(k));
}

/** Lajitteluvalinnat: Pelit + valitut mittarit (kiinteä järjestys) */
export function getSortableMetricKeys(visibleMetrics) {
  const ordered = getOrderedLeaderboardMetrics(visibleMetrics);
  return ['games', ...ordered];
}

export function ensureValidLeaderboardSort(settings) {
  const keys = getSortableMetricKeys(settings.visibleMetrics);
  const sortBy = keys.includes(settings.sortBy) ? settings.sortBy : keys.includes('points') ? 'points' : keys[0];
  const sortDirection = settings.sortDirection === 'asc' ? 'asc' : 'desc';
  return { ...settings, sortBy, sortDirection };
}

/**
 * @param {string} sortBy - 'games' | 'time' | 'points' | 'winRate' | 'avgPoints'
 * @param {string} sortDirection - 'asc' | 'desc'
 * @param {boolean} futureMode - points: futurePoints; games: futureTotalGames; avgPoints: futureAvgPointsPerGame
 */
export function sortLeaderboardRows(rows, sortBy, sortDirection, futureMode) {
  const dir = sortDirection === 'asc' ? 1 : -1;

  const value = (row) => {
    switch (sortBy) {
      case 'games':
        if (futureMode && row.futureTotalGames != null) {
          return Number(row.futureTotalGames) || 0;
        }
        return Number(row.gamesPlayed) || 0;
      case 'time':
        return Number(row.totalPlaytime) || 0;
      case 'points':
        if (futureMode && row.futurePoints != null) return Number(row.futurePoints) || 0;
        return Number(row.totalPoints) || 0;
      case 'winRate':
        return row.winRate != null && !Number.isNaN(Number(row.winRate)) ? Number(row.winRate) : -1;
      case 'avgPoints':
        if (
          futureMode &&
          row.futureAvgPointsPerGame != null &&
          !Number.isNaN(Number(row.futureAvgPointsPerGame))
        ) {
          return Number(row.futureAvgPointsPerGame);
        }
        return row.avgPointsPerGame != null && !Number.isNaN(Number(row.avgPointsPerGame))
          ? Number(row.avgPointsPerGame)
          : -1;
      default:
        return Number(row.totalPoints) || 0;
    }
  };

  return [...rows].sort((a, b) => {
    const va = value(a);
    const vb = value(b);
    if (va !== vb) return (va - vb) * dir;
    return String(a.name || '').localeCompare(String(b.name || ''), 'fi', { sensitivity: 'base' });
  });
}
